import { CumulativeRainfallDTO } from './CumulativeRainfallDTO'
import { LegendsDTO } from './LegendsDTO'

export class SettingDTO {
  constructor(
    readonly defaultLanguage: string,
    readonly cellSize: number,
    readonly legends: LegendsDTO,
    readonly hasRainGauges: boolean,
    readonly cumulativeRainfall: CumulativeRainfallDTO[],
  ) {}
}
